import { render, staticRenderFns } from "./QuotationCreatePage.vue?vue&type=template&id=7f387bff&scoped=true"
import script from "./QuotationCreatePage.vue?vue&type=script&lang=js"
export * from "./QuotationCreatePage.vue?vue&type=script&lang=js"
import style0 from "./QuotationCreatePage.vue?vue&type=style&index=0&id=7f387bff&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f387bff",
  null
  
)

export default component.exports